import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteControl } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.DELETE,
  api: deleteControl,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controls/DeleteAction.js